module.exports = __webpack_public_path__ + "img/group_bg.25b6d054.png";